import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  partnerDataFulfilled,
  partnerDataPending,
  partnerDataRejected,
} from 'legacy/lut/features/partner360/configuration'
import { requestUpdatePartnerBaseMetrics } from 'legacy/lut/features/partner360/shareOfBusiness/api/requestUpdatePartnerBaseMetrics'
import { requestUpdatePartnerDevicesInfo } from 'legacy/lut/features/partner360/shareOfBusiness/api/requestUpdatePartnerDevicesInfo'
import { requestUpdateTopVendorBrands } from 'legacy/lut/features/partner360/shareOfBusiness/api/requestUpdateTopVendorBrands'
import { map621ToShareOfBusiness } from 'legacy/lut/services/partner360/shareOfBusiness/mappings/map621ToShareOfBusiness'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { initialState } from './configs'
import { PARTNER360_SHARE_OF_BUSINESS_NAMESPACE } from './constants'
import { IShareOfBusiness } from './models/IShareOfBusiness'

const shareOfBusinessSlice = createSlice({
  initialState,
  name: PARTNER360_SHARE_OF_BUSINESS_NAMESPACE,
  reducers: {
    loadShareOfBusinessData: (state, action: PayloadAction<IShareOfBusiness>) => {
      state.data = action.payload
      state.status = RequestStatus.FULFILLED
      state.message = 'Data is loaded'
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(partnerDataPending, (state) => {
        state.status = RequestStatus.PENDING
        state.message = 'fetching data...'
      })
      .addCase(partnerDataRejected, (state, action) => {
        state.status = RequestStatus.REJECTED
        if (action.payload) {
          state.message = action.payload
        }
      })
      .addCase(partnerDataFulfilled, (state, action) => {
        state.status = RequestStatus.FULFILLED
        state.message = 'Success'
        state.data = map621ToShareOfBusiness(action.payload)
      })

      .addCase(requestUpdatePartnerDevicesInfo.pending, (state) => {
        state.status = RequestStatus.PENDING
        state.message = 'Updating PartnerDevicesInfo...'
      })
      .addCase(requestUpdatePartnerDevicesInfo.rejected, (state, action) => {
        state.status = RequestStatus.REJECTED
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(requestUpdatePartnerDevicesInfo.fulfilled, (state, action) => {
        const { isShareOfBusinessUpdated, data } = action.payload
        state.status = RequestStatus.FULFILLED
        state.message = isShareOfBusinessUpdated
          ? 'PartnerDevicesInfo & SOB updated.'
          : 'PartnerDevicesInfo updated. No need to update SOB.'

        state.data = data
      })

      .addCase(requestUpdatePartnerBaseMetrics.pending, (state) => {
        state.status = RequestStatus.PENDING
        state.message = 'Updating PartnerBaseMetrics...'
      })
      .addCase(requestUpdatePartnerBaseMetrics.rejected, (state, action) => {
        state.status = RequestStatus.PENDING
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(requestUpdatePartnerBaseMetrics.fulfilled, (state, action) => {
        state.status = RequestStatus.FULFILLED
        state.message = 'PartnerBaseMetrics updated'

        state.data = action.payload
      })

      .addCase(requestUpdateTopVendorBrands.pending, (state) => {
        state.status = RequestStatus.PENDING
        state.message = 'Updating top vendor brands...'
      })
      .addCase(requestUpdateTopVendorBrands.rejected, (state, action) => {
        state.status = RequestStatus.PENDING
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(requestUpdateTopVendorBrands.fulfilled, (state, action) => {
        state.status = RequestStatus.FULFILLED
        state.message = 'TopVendorBrands updated'

        state.data = action.payload
      }),
})

export const { loadShareOfBusinessData } = shareOfBusinessSlice.actions

export default shareOfBusinessSlice.reducer
